import { SELECTORS } from './constants';

function playVideo(playBtn, videoEl, icon) {
  videoEl.play();
  playBtn.setAttribute('aria-label', 'Pause');
  icon.innerHTML = '<path d="M13 1v14H9V1zM7 1v14H3V1z"></path>';
}

function stopVideo(playBtn, videoEl, icon) {
  videoEl.pause();
  playBtn.setAttribute('aria-label', 'Play');
  icon.innerHTML =
    '<path d="m4.504 1.0074c-.2305-.134-.5-.171-.7585-.103-.2136.05621-.4026.18157-.5375.35651-.1348.17494-.208.3896-.208.61049v12.2595c.0003.1758.0468.3485.135.5006s.2149.2783.3674.3659c.1524.0876.3253.1335.5011.1331052.1759-.0005052.3485-.0472052.5005-.1356052l10.5075-6.13c.1505-.0884.2753-.2145.362-.3659.0867-.1515.1324002-.3229.1324002-.4975 0-.1745-.0455002-.346-.1321002-.4975-.0866-.1514-.2114-.2777-.3618-.3661z"></path>';
}

function setupPlayButton(playBtn, videoEl, icon) {
  playBtn.addEventListener('click', () => {
    if (videoEl.paused) {
      playVideo(playBtn, videoEl, icon);
    } else {
      stopVideo(playBtn, videoEl, icon);
    }
  });
}

function setupHover(videoEl, playBtn, icon) {
  videoEl.addEventListener('mouseenter', (e) => {
    if (videoEl.paused && e.curentTarget !== playBtn) {
      playVideo(playBtn, videoEl, icon);
    }
  });
}

function setupVideoTimeUpdate(videoEl, playBtn, icon, progressBar, progress) {
  videoEl.addEventListener('timeupdate', () => {
    progressBar.setAttribute(
      'aria-valuenow',
      (videoEl.currentTime / videoEl.duration) * 100
    );

    progress.style.strokeDashoffset =
      87.9645943005 -
      (videoEl.currentTime / videoEl.duration) * 87.9645943005 +
      'px';

    if (videoEl.currentTime === videoEl.duration) {
      stopVideo(playBtn, videoEl, icon);
    }
  });
}

function disableContextMenu(videoEl) {
  videoEl.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    e.stopPropagation();
  });
}

function setupVideo() {
  const videos = document.querySelectorAll(SELECTORS.videoContainer);

  videos.forEach((videoContainer) => {
    const videoElement = videoContainer.querySelector(SELECTORS.videoElement);
    const playBtn = videoContainer.querySelector(SELECTORS.videoPlayButton);
    const progressBarContainer = videoContainer.querySelector(
      SELECTORS.videoPlayButtonIcon
    );
    const progressElement = videoContainer.querySelector(
      SELECTORS.videoProgressBarElement
    );
    const icon = videoContainer.querySelector(SELECTORS.videoPlayButtonIcon);

    disableContextMenu(videoElement);
    setupPlayButton(playBtn, videoElement, icon);
    setupHover(videoElement, playBtn, icon);
    setupVideoTimeUpdate(
      videoElement,
      playBtn,
      icon,
      progressBarContainer,
      progressElement
    );
  });
}

export { setupVideo };
